import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { prebuiltActionsService, PrebuiltAction } from '@/services/prebuiltActionsService';
import { RootState } from '@/store/store';

// Async thunk
export const fetchPrebuiltActions = createAsyncThunk(
  'prebuiltActions/fetchPrebuiltActions',
  async () => {
    const response = await prebuiltActionsService.getPrebuiltActions();
    console.log('response', response);
    return response;
  }
);

export const fetchPrebuildSelectedApps = createAsyncThunk(
  'prebuiltActions/fetchPrebuildSelectedApps',
  async () => {
    const response = await prebuiltActionsService.getPrebuildSelectedApps();
    return response.data;
  }
);

// State interface
interface PrebuiltActionsState {
  items: PrebuiltAction[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: PrebuiltActionsState = {
  items: [],
  loading: false,
  error: null,
};

// Slice
const prebuiltActionsSlice = createSlice({
  name: 'prebuiltActions',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrebuiltActions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrebuiltActions.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchPrebuiltActions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch prebuilt actions';
      })
      .addCase(fetchPrebuildSelectedApps.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrebuildSelectedApps.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchPrebuildSelectedApps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch prebuild selected apps';
      });
  },
});

//Provide selector for items
export const selectPrebuiltActions = (state: RootState) =>{
    console.log('state', state);
    return state.prebuiltActions.items;
}
export const selectPrebuiltActionsLoading = (state: RootState) => state.prebuiltActions.loading;
export const selectPrebuiltActionsError = (state: RootState) => state.prebuiltActions.error;
// Export actions
export const { clearError } = prebuiltActionsSlice.actions;

// Export reducer
export default prebuiltActionsSlice.reducer; 